
import {
  Table as MuiTable,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from '@mui/material';
import './table.scss';

interface TableProps {
  tableData?: any;
  tableHead?: any[];
}
const tableHead = [
  {
    name: "Dish Name",
  },
  {
    name: "Dish UOM",
  },
  {
    name: "Dish Variant Name",
  },
  {
    name: "Projected Qty",
  },
  {
    name: "Requested Qty",
  },
  {
    name: "Variance %",
  },
];
const QuantitiesVarianceReportTable: React.FC<TableProps> = ({ tableData }) => {
  
  return (
    <div className="table-wrapper QuantitieVarianceReportTable">
      <TableContainer component={Paper} className="table-inner" sx={{ maxHeight: 440 }}>
        <MuiTable stickyHeader>
          <TableHead>
            <TableRow>
              {tableHead.map((col:any, index:number) => (
                <TableCell key={index}>
                  <Typography variant="h6" className="table-title">
                    {col?.name}
                  </Typography>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {tableData?.length > 0 ? (
              tableData.map((row:any, index:number) => (
                <TableRow key={index}>
                  <TableCell>{row?.dishname}</TableCell>
                  <TableCell>{row?.dishuom}</TableCell>
                  <TableCell>{row?.dishvariantname} {row?.dishvariantuom} {row?.dishvariantuom === 'Pcs' && row?.weightperpc !== 0 ? (
                        ` @${row?.weightperpc} gms`
                      ) : null}</TableCell>
                  <TableCell>{row?.projectedqty} {row?.dishvariantuom === 'gms' ? "Kg" : row?.dishvariantuom}</TableCell>
                  <TableCell>{row?.requestedqty} {row?.dishvariantuom === 'gms' ? "Kg" : row?.dishvariantuom}</TableCell>
                  <TableCell>{row?.variance}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={tableHead.length} className="grey-bg center">
                  No data found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </MuiTable>
      </TableContainer>
    </div>
  );
};

export default QuantitiesVarianceReportTable;
